module.exports = __webpack_public_path__ + "img/logo.9cfb4ff9.png";